import { Card } from "@/components/ui/card";
import { EmptyState } from "@/components/ui/EmptyState";
import { Database } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useActiveDataset } from "@/contexts/ActiveDatasetContext";

/** Live preview of the shared working dataset — real rows, never samples. */
export const DataPreview = () => {
  const { dataset } = useActiveDataset();

  if (!dataset || dataset.rows.length === 0) {
    return (
      <Card className="p-6">
        <h2 className="text-lg font-semibold mb-4">Data preview</h2>
        <EmptyState
          icon={Database}
          title="No data loaded"
          description="Upload a CSV or Excel file in the cleaner above to preview your rows here."
        />
      </Card>
    );
  }

  const columns = dataset.columns.slice(0, 12);
  const rows = dataset.rows.slice(0, 25);

  return (
    <Card className="p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold">Data preview</h2>
        <p className="text-sm text-muted-foreground">
          Showing {rows.length} of {dataset.rows.length} rows
        </p>
      </div>
      <div className="overflow-x-auto rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              {columns.map((c) => (
                <TableHead key={c}>{c}</TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={i}>
                {columns.map((c) => (
                  <TableCell key={c} className="max-w-[220px] truncate">
                    {row[c] === null || row[c] === undefined || row[c] === ""
                      ? "—"
                      : String(row[c])}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      {dataset.columns.length > columns.length && (
        <p className="text-xs text-muted-foreground mt-2">
          {dataset.columns.length - columns.length} more columns not shown.
        </p>
      )}
    </Card>
  );
};
